import { motion } from "framer-motion";
import { Plane } from "lucide-react";
import { useLanguage } from "@/i18n";
import { ASSETS } from "@/data";

export default function Memorial() {
  const { t } = useLanguage();

  return (
    <section
      id="memorial"
      data-testid="memorial-section"
      className="relative overflow-hidden bg-[#030409] py-24 sm:py-32"
    >
      <div className="pointer-events-none absolute left-1/2 top-1/2 h-[480px] w-[480px] -translate-x-1/2 -translate-y-1/2 rounded-full bg-slate-400/5 blur-[130px]" />

      <div className="relative mx-auto max-w-3xl px-4 text-center sm:px-6">
        <motion.div
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 1.2 }}
          className="mb-10 flex items-center justify-center gap-4"
        >
          <span className="h-px w-10 bg-slate-700 sm:w-16" />
          <Plane className="h-4 w-4 text-slate-500" />
          <span className="font-pixel text-[10px] tracking-[0.4em] text-slate-400">
            {t.memorial.label}
          </span>
          <Plane className="h-4 w-4 -scale-x-100 text-slate-500" />
          <span className="h-px w-10 bg-slate-700 sm:w-16" />
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 32 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-60px" }}
          transition={{ duration: 1.2, delay: 0.2, ease: [0.16, 1, 0.3, 1] }}
          className="relative mx-auto max-w-md"
        >
          <div className="pointer-events-none absolute -inset-3 border border-white/10" />
          <img
            src={ASSETS.lito}
            alt="Homenagem a Lito Sousa (1967 — 2026)"
            data-testid="memorial-image"
            className="relative w-full border border-white/15 shadow-[0_0_90px_rgba(148,163,184,0.12)]"
          />
        </motion.div>
      </div>
    </section>
  );
}
